import {
  CLEAN_ERROR_MESSAGE,
  CLEAR_R_N_M,
  DETECT_REGION,
  MOSCOW_SCENARIO_CLEAR_REGION,
  R_N_M_FIFTH_STEP_LOADING_FAILED,
  R_N_M_FIFTH_STEP_LOADING_FAILED_WITH_MESSAGE,
  R_N_M_FIFTH_STEP_LOADING_SUCCESS,
  R_N_M_FIRST_STEP_LOADING_FAILED,
  R_N_M_FIRST_STEP_LOADING_SUCCESS,
  R_N_M_FOURTH_STEP_LOADING_FAILED,
  R_N_M_FOURTH_STEP_LOADING_STARTED,
  R_N_M_FOURTH_STEP_LOADING_SUCCESS,
  R_N_M_SECOND_STEP_LOADING_FAILED,
  R_N_M_SECOND_STEP_LOADING_SUCCESS,
  R_N_M_SIXTH_STEP_LOADING_FAILED,
  R_N_M_SIXTH_STEP_LOADING_SUCCESS,
  R_N_M_THIRD_STEP_LOADING_FAILED,
  R_N_M_THIRD_STEP_LOADING_SUCCESS,
  RESTART_STEPS,
  SELECT_MEDICAL_ORGANISATION,
  SELECT_REGION,
  SET_ERROR_MESSAGE,
} from "./types";
import {
  panels,
  R_N_M_FIFTH_STEP_ADDRESS,
  R_N_M_FIRST_STEP_ADDRESS,
  R_N_M_FOURTH_STEP_ADDRESS,
  R_N_M_SECOND_STEP_ADDRESS,
  R_N_M_SIX_STEP_ADDRESS,
} from "../../variables";
import {
  checkErrorStatusAndExecuteCallback,
  replaceAllDivisiosToDots,
} from "../../utils";
import { hideRegionsLoader, showRegionsLoader } from "./loaderActions";
import { setActivePanel, setErrorPanel } from "./panelsActions";
import store from "../store";
import { updateSessionId } from "./userInfoActions";
import { HealthCheckEvents } from "../../api/types";
import Api from "../../api";
import {
  hasResponseErrorCode,
  parceErrorData,
  throwErrorMessageFromResponse,
} from "../../helpers/redux";

export const startFirstStepLoading = () => (dispatch, getState) => {
  const detectedRegion = getState().regionAndMedicalOrganisation.detectedRegion;
  const data = {
    "userSelectedRegion" : detectedRegion?.OKATO,
    "eServiceCode": "10000103595",
    "serviceTargetCode": "-10000000633"
  }

  Api.instance
    .post(R_N_M_FIRST_STEP_ADDRESS, data)
    .then((response) => {
      throwErrorMessageFromResponse(response);
      dispatch(firstStepLoadingSuccess(response.data.id));
    })
    .catch((error) => {
      const [errorMessage, isCustom] = parceErrorData(error);
      dispatch(firstStepLoadingFailed(error));
      dispatch(setErrorPanel(errorMessage, isCustom))
    });
};

export const firstStepLoadingSuccess = (orderId) => {
  return {
    type: R_N_M_FIRST_STEP_LOADING_SUCCESS,
    payload: orderId,
  };
};

export const restartSteps = () => {
  return {
    type: RESTART_STEPS,
  };
};

export const firstStepLoadingFailed = (error) => {
  return {
    type: R_N_M_FIRST_STEP_LOADING_FAILED,
    payload: {
      error,
    },
  };
};

export const startSecondStepLoading = () => (dispatch, getState) => {
  const healthCheckInstance = Api.healthCheckFor(
    HealthCheckEvents.getRegionList
  );
  const regionsLoader = getState().loader.showRegionsLoader;

  if (regionsLoader) {
    return;
  }

  const data = {
    treeFiltering: "ONELEVEL",
    pageNum: 1,
    pageSize: 100,
    parentRefItemValue: "",
    selectAttributes: ["*"],
    tx: "",
  };

  dispatch(showRegionsLoader());

  Api.instance
    .post(R_N_M_SECOND_STEP_ADDRESS, data, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      timeout: 40_000,
    })
    .then((response) => {
      throwErrorMessageFromResponse(response);

      dispatch(loadUserRegion());
      dispatch(
        secondStepLoadingSuccess(
          response.data.items.map(mapResponseItemsToUsable)
        )
      );

      healthCheckInstance.sendSuccess();
    })
    .catch((error) => {
      const [errorMessage, isCustom] = parceErrorData(error);
      const activePanel = store.getState().panels.activePanel;

      dispatch(secondStepLoadingFailed(error));
      healthCheckInstance.sendFailure({ browserError: errorMessage });

      if (activePanel === panels.regionAndMedicalOrganisation) {
        dispatch(setErrorPanel(errorMessage, isCustom));
      }
    })
    .finally(() => dispatch(hideRegionsLoader()));
};

const mapResponseItemsToUsable = (item) => {
  return {
    regionCode: item.value,
    name: item.title,
    OKATO: item.attributeValues?.OKATO,
  };
};

export const secondStepLoadingSuccess = (regions) => {
  return {
    type: R_N_M_SECOND_STEP_LOADING_SUCCESS,
    payload: regions,
  };
};

export const secondStepLoadingFailed = (error) => {
  return {
    type: R_N_M_SECOND_STEP_LOADING_FAILED,
    payload: {
      error,
    },
  };
};

export const startThirdStepLoading = () => (dispatch) => {
  let config = {
    headers: {
      Accept: "application/json, text/plain, */*",
    },
  };

  Api.instance.post("/health/v2/check-restrictions/10068/2?_=" + Math.random(), {}, config)
    .then((response) => {
      throwErrorMessageFromResponse(response);
      if (response.status === 200) {
        dispatch(thirdStepLoadingSuccess());
      } else {
        dispatch(thirdStepLoadingSuccess(["Получение услуги запрещено"]));
      }
    })
    .catch((error) => {
      const [errorMessage, isCustom] = parceErrorData(error);
      dispatch(thirdStepLoadingFailed(error.message));
      dispatch(setErrorPanel(errorMessage, isCustom));
    });
};

export const thirdStepLoadingSuccess = (prohibitions) => (dispatch) => {
  dispatch(hideRegionsLoader());

  return {
    type: R_N_M_THIRD_STEP_LOADING_SUCCESS,
    payload: prohibitions,
  };
};

export const thirdStepLoadingFailed = (error) => {
  return {
    type: R_N_M_THIRD_STEP_LOADING_FAILED,
    payload: {
      error,
    },
  };
};

export const startFourthStepLoading = (regionOKATO) => (dispatch) => {
  let config = {
    method: "get",
    headers: {
      Accept: "application/json, text/plain, */*",
    },
    withCredentials: true,
  };
  dispatch(fourthStepLoadingStarted());
  dispatch(showRegionsLoader());
  dispatch(cleanErrorMessage());
  Api.instance.get(R_N_M_FOURTH_STEP_ADDRESS + regionOKATO + "/service/10068?_=" + Math.random(), config)
    .then((response) => {
      throwErrorMessageFromResponse(response);
      if (response.status === 200) {
        dispatch(fourthStepLoadingSuccess(true));
      } else if (response.status === 404) {
        dispatch(fourthStepLoadingSuccess(false));
      } else {
        throw Error();
      }
    })
    .catch((error) => {
      const [errorMessage, isCustom] = parceErrorData(error);
      dispatch(fourthStepLoadingFailed(error));
      dispatch(setErrorPanel(errorMessage, isCustom));
    })
};

export const fourthStepLoadingStarted = () => {
  return {
    type: R_N_M_FOURTH_STEP_LOADING_STARTED,
  };
};

export const fourthStepLoadingSuccess = (available) => {
  return {
    type: R_N_M_FOURTH_STEP_LOADING_SUCCESS,
    payload: available,
  };
};

export const fourthStepLoadingFailed = (error) => {
  return {
    type: R_N_M_FOURTH_STEP_LOADING_FAILED,
    payload: {
      error,
    },
  };
};

export const startFifthStepLoading =
  (userInfo, selectedRegion, user, orderId, snils) => (dispatch) => {
    const healthCheckInstance = Api.healthCheckFor(HealthCheckEvents.patientValidation);
    const birthDate = userInfo.birthDate ? userInfo.birthDate.slice(0, 10) : "";
    const [series, number] = getOMSSeriesAndNumber(getOMS(userInfo));
    const data = {
      eserviceId: "10000103595",
      parentRefItemValue: null,
      refName: "getValidatePatient", // параметр, определяющий специфику запроса - в данном случае - проверка Пациента и присвоение ему ИД в рамках данной услуги
      treeFiltering: "ONELEVEL",
      filter: {
        union: {
          unionKind: "AND",
          subs: [
            {
              simple: {
                attributeName: "userType",
                checkAllValues: true,
                condition: "EQUALS",
                value: "PERSON_RF"
              }
            },
            {
              simple: {
                attributeName: "esiaId",
                checkAllValues: true,
                condition: "EQUALS",
                value: userInfo.userId
              }
            },
            {
              simple: {
                attributeName: "userSnils",
                checkAllValues: true,
                condition: "EQUALS",
                value: userInfo.snils || snils
              }
            },
            {
              simple: {
                attributeName: "isUserRecord",
                checkAllValues: true,
                condition: "EQUALS",
                value: "1"
              }
            },
            {
              simple: {
                attributeName: "lastName",
                checkAllValues: true,
                condition: "EQUALS",
                value: userInfo.lastName
              }
            },
            {
              simple: {
                attributeName: "firstName",
                checkAllValues: true,
                condition: "EQUALS",
                value: userInfo.firstName
              }
            },
            {
              simple: {
                attributeName: "middleName",
                checkAllValues: true,
                condition: "EQUALS",
                value: userInfo.middleName || "",
              }
            },
            {
              simple: {
                attributeName: "birthdate",
                checkAllValues: true,
                condition: "EQUALS",
                value: replaceAllDivisiosToDots(birthDate) || "01.01.1970",
              }
            },
            {
              simple: {
                attributeName: "OMS_Number",
                checkAllValues: true,
                condition: "EQUALS",
                value: number
              }
            },
            {
              simple: {
                attributeName: "patientSnils",
                checkAllValues: true,
                condition: "EQUALS",
                value: userInfo.snils || snils,
              }
            },
            {
              simple: {
                attributeName: "regionCode",
                checkAllValues: true,
                condition: "EQUALS",
                value: selectedRegion.regionCode.toString(),
              }
            },
            {
              simple: {
                attributeName: "Session_Id",
                checkAllValues: true,
                condition: "EQUALS",
                value: userInfo.sessionId,
              }
            },
            {
              simple: {
                attributeName: "sex",
                checkAllValues: true,
                condition: "EQUALS",
                value: userInfo.gender === "M" ? 1 : 2,
              }
            },
          ],
        },
      },
    };
    dispatch(showRegionsLoader());
    Api.instance.post(R_N_M_FIFTH_STEP_ADDRESS, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=utf-8",
      },
    })
      .then((response) => {
        if (hasResponseErrorCode(response)) {
          dispatch(fifthStepLoadingFailedWithMessage(response.data));
          dispatch(hideRegionsLoader());
        } else {
          healthCheckInstance.sendSuccess();
          dispatch(fifthStepLoadingSuccess({...response.data, error: null}));
        }
      })
      .catch((error) => {
        healthCheckInstance.sendFailure({ browserError: error.message });
        dispatch(fifthStepLoadingFailed(error));
        checkErrorStatusAndExecuteCallback(error, () =>
          dispatch(setActivePanel(panels.error))
        );
      });
  };

const getOMSSeriesAndNumber = (omsString) => {
  omsString = omsString.trim();
  const spaceIndex = omsString.indexOf(" ");
  if (spaceIndex > 0) {
    return [
      omsString.substring(0, spaceIndex),
      omsString.substring(spaceIndex + 1, omsString.length),
    ];
  } else {
    return ["", omsString];
  }
};

const getOMS = (userInfo) => {
  const docs = userInfo.person.docs;
  for (let i = 0; i < docs.length; i++) {
    if (docs[i].type === "MDCL_PLCY") {
      return docs[i].number || "";
    }
  }
  return "";
};

export const fifthStepLoadingSuccess = (patientChecks) => {
  return {
    type: R_N_M_FIFTH_STEP_LOADING_SUCCESS,
    payload: patientChecks,
  };
};

export const moscowScenarioClearRegion = () => {
  return {
    type: MOSCOW_SCENARIO_CLEAR_REGION,
  };
};

export const fifthStepLoadingFailed = (error) => {
  return {
    type: R_N_M_FIFTH_STEP_LOADING_FAILED,
    payload: {
      error,
    },
  };
};

export const fifthStepLoadingFailedWithMessage = (payload) => {
  return {
    type: R_N_M_FIFTH_STEP_LOADING_FAILED_WITH_MESSAGE,
    payload
  };
};

export const startSixthStepLoading =
  (userInfo, orderId, selectedRegion, user) => (dispatch) => {
    const healthCheckInstance = Api.healthCheckFor(HealthCheckEvents.getMOList);
    const data = {
        "eserviceId": 10000103595,
        "refName": "MO",
        "treeFiltering": "ONELEVEL",
        "filter": {
          "union": {
            "unionKind": "AND",
            "subs": [
              {
                "simple": {
                  "attributeName": "Session_Id",
                  "condition": "EQUALS",
                  "value":  userInfo.sessionId,
                }
              },
              {
                "simple": {
                  "attributeName": "Reg_Code",
                  "condition": "EQUALS",
                  "value": selectedRegion
                    ? selectedRegion.regionCode.toString()
                    : ""
                }
              }
            ]
          }
        },
        "pageNum": 0,
        "pageSize": 100
      }
    const config = {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    };
    dispatch(showRegionsLoader());
    Api.instance
      .post(R_N_M_SIX_STEP_ADDRESS, data, config)
      .then((response) => {
        throwErrorMessageFromResponse(response);

        dispatch(
          sixthStepLoadingSuccess(
            response.data.items.map(mapMedicalOrganisation)
          )
        );

        healthCheckInstance.sendSuccess();
      })
      .catch((error) => {
        const [errorMessage, isCustom] = parceErrorData(error);
        dispatch(sixthStepLoadingFailed(error));
        healthCheckInstance.sendFailure({ browserError: error.message });
        dispatch(setErrorPanel(errorMessage, isCustom));
      })
      .finally(() => dispatch(hideRegionsLoader()));
  };

const mapMedicalOrganisation = (MO) => {
  return MO.attributes.reduce((prev, {name, value}) => {
    prev[name] = value
    return prev
  }, {})
};

export const sixthStepLoadingSuccess = (items) => {
  return {
    type: R_N_M_SIXTH_STEP_LOADING_SUCCESS,
    payload: items,
  };
};

export const sixthStepLoadingFailed = (error) => {
  return {
    type: R_N_M_SIXTH_STEP_LOADING_FAILED,
    payload: {
      error,
    },
  };
};

export const selectMedicalOrganisation = (selectedMedicalOrganisation) => {
  return {
    type: SELECT_MEDICAL_ORGANISATION,
    payload: selectedMedicalOrganisation,
  };
};

export const selectRegion = (selectedRegion) => {
  updateSessionId();
  if (!selectedRegion) {
    selectedRegion = "";
  }
  return {
    type: SELECT_REGION,
    payload: selectedRegion,
  };
};

export const detectRegion = (region) => {
  updateSessionId();
  if (!region) {
    region = "";
  }
  return {
    type: DETECT_REGION,
    payload: region,
  };
};

export const setErrorMessage = (message) => {
  return {
    type: SET_ERROR_MESSAGE,
    payload: message,
  };
};
export const cleanErrorMessage = () => {
  return {
    type: CLEAN_ERROR_MESSAGE,
  };
};

/*const testOrganisationsList = [
  {
    value: "2i::193",
    parentValue: null,
    title:
      'Поликлиническое отделение №104, СПб ГБУЗ "Городская поликлиника №104"',
    isLeaf: true,
    children: [],
    attributes: [
      {
        name: "MO_Id",
        type: "STRING",
        value: {
          asString: "2i::193",
          asLong: null,
          asDecimal: null,
          asDateTime: null,
          asDate: null,
          asBoolean: null,
          typeOfValue: "STRING",
          value: "2i::193",
        },
        valueAsOfType: "2i::193",
      },
      {
        name: "Organization_Name",
        type: "STRING",
        value: {
          asString:
            'Поликлиническое отделение №104, СПб ГБУЗ "Городская поликлиника №104"',
          asLong: null,
          asDecimal: null,
          asDateTime: null,
          asDate: null,
          asBoolean: null,
          typeOfValue: "STRING",
          value:
            'Поликлиническое отделение №104, СПб ГБУЗ "Городская поликлиника №104"',
        },
        valueAsOfType:
          'Поликлиническое отделение №104, СПб ГБУЗ "Городская поликлиника №104"',
      },
      {
        name: "Address_MO",
        type: "STRING",
        value: {
          asString: "194354, Санкт-Петербург, ул. Сикейроса, д. 10",
          asLong: null,
          asDecimal: null,
          asDateTime: null,
          asDate: null,
          asBoolean: null,
          typeOfValue: "STRING",
          value: "194354, Санкт-Петербург, ул. Сикейроса, д. 10",
        },
        valueAsOfType: "194354, Санкт-Петербург, ул. Сикейроса, д. 10",
      },
      {
        name: "Reg_Phone",
        type: "STRING",
        value: {
          asString: "(812) 296-35-05",
          asLong: null,
          asDecimal: null,
          asDateTime: null,
          asDate: null,
          asBoolean: null,
          typeOfValue: "STRING",
          value: "(812) 296-35-05",
        },
        valueAsOfType: "(812) 296-35-05",
      },
    ],
    attributeValues: {
      MO_Id: "2i::193",
      Reg_Phone: "(812) 296-35-05",
      Organization_Name:
        'Поликлиническое отделение №104, СПб ГБУЗ "Городская поликлиника №104"',
      Address_MO: "194354, Санкт-Петербург, ул. Сикейроса, д. 10",
    },
  },
];*/

export const loadUserRegion = () => (dispatch, getState) => {
  const config = {
    method: "get",
    withCredentials: true,
  };

  Api.instance
    .get("/health/v1/nsi/v1/epgu/detectRegion", config)
    .then((response) => {
      if (response.status === 200) {
        const codesOKATO = response.data.codes;
        const regions = getState().regionAndMedicalOrganisation.regions;
        let currentRegion = null;

        codesOKATO.forEach((item) => {
          regions.forEach((itemR) => {
            if (itemR.OKATO === item) currentRegion = itemR;
          });
        });

        if (currentRegion) {
          dispatch(detectRegion(currentRegion));
          dispatch(selectMedicalOrganisation(null));
        }
      }
    })
    .catch((error) => {
      checkErrorStatusAndExecuteCallback(error, () =>
        dispatch(setActivePanel(panels.error))
      );
    });
};

export const clearRegionAndMedicalOrganisation = () => {
  return {
    type: CLEAR_R_N_M,
  };
};
